import React, { useState } from "react";

export default function RoundEnquiryGateModal({
  isOpen,
  onClose,
  onContinue,
}) {
  const [acknowledged, setAcknowledged] = useState(false);

  if (!isOpen) return null;

  return (
    <div style={overlay}>
      <div style={modal}>
        <h2 style={title}>Before you contact the seller</h2>

        <p style={primaryText}>
          <strong>This listing is for the sale of the entire round only.</strong>
        </p>

        <p style={text}>
          Individual clients are <strong>not available</strong> from this
          listing.
        </p>

        <p style={text}>
          If you are interested in purchasing individual clients, please browse
          the <strong>Client Listings</strong> section instead.
        </p>

        <div style={checkboxRow}>
          <input
            type="checkbox"
            id="ack"
            checked={acknowledged}
            onChange={(e) => setAcknowledged(e.target.checked)}
          />
          <label htmlFor="ack" style={checkboxLabel}>
            I understand this round must be sold as a whole and not as individual
            clients
          </label>
        </div>

        <div style={actions}>
          <button style={cancelBtn} onClick={onClose}>
            Cancel
          </button>

          <button
            style={{
              ...continueBtn,
              opacity: acknowledged ? 1 : 0.5,
              cursor: acknowledged ? "pointer" : "not-allowed",
            }}
            disabled={!acknowledged}
            onClick={() => {
              onContinue();
              onClose();
            }}
          >
            Continue to message seller
          </button>
        </div>
      </div>
    </div>
  );
}

/* =========================
   STYLES
========================= */

const overlay = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  background: "rgba(0,0,0,0.45)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modal = {
  background: "#fff",
  padding: "25px",
  borderRadius: "10px",
  width: "100%",
  maxWidth: "480px",
  boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
};

const title = {
  marginBottom: "15px",
  color: "#2e7d32",
};

const primaryText = {
  fontSize: "16px",
  marginBottom: "10px",
};

const text = {
  fontSize: "14px",
  marginBottom: "10px",
  color: "#444",
};

const checkboxRow = {
  display: "flex",
  gap: "10px",
  alignItems: "flex-start",
  marginTop: "15px",
};

const checkboxLabel = {
  fontSize: "14px",
  color: "#333",
};

const actions = {
  display: "flex",
  justifyContent: "flex-end",
  gap: "10px",
  marginTop: "25px",
};

const cancelBtn = {
  padding: "10px 14px",
  border: "1px solid #ccc",
  background: "#f5f5f5",
  borderRadius: "6px",
  cursor: "pointer",
};

const continueBtn = {
  padding: "10px 16px",
  border: "none",
  background: "#2e7d32",
  color: "#fff",
  borderRadius: "6px",
};
